module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Simplon-bb87a37bca57e66c01ad338f1760bf09.png";